import { useContext, useEffect, useRef, useState } from "react";
import {
  ParagraphText,
  UBButton,
  UBInput,
  UBRadioBox,
} from "../../../../Libraries";
import { RouteLeavingGuard, TitleAndActionBox } from "../../../common";
import ConfirmationModal from "../../../common/Modals/ConfirmationModal";
import { LanguageContext } from "../../../../context/LanguageContext";
import { Box, CircularProgress, Grid } from "@mui/material";
import styles from "../../SaleExpense/SaleExpenseForm/styles.module.css";
import accountStyles from "../../../Features/Account/styles.module.css";
import { EnterIcon } from "../../../../assets/icons/icon";
import {
  isUserExist,
  isUserExistForUpdation,
  uuid,
} from "../../../../oscar-pos-core/constants";
import { sentenceCase } from "../../../../constants";
import {
  findCustomerByID,
  getCustomerOfBusiness,
} from "../../../../database/helpers/customer";
import withObservables from "@nozbe/with-observables";

import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { Sync } from "../../../../SyncService";
import { useAuthContext } from "../../../../context/AuthContext";
import { useSnackbar } from "../../../../context/SnackbarContext";
import { useLocation, useNavigate } from "react-router-dom";
import BusinessLoader from "../../../common/BusinessLoader";
import DeleteAccount from "../DeleteAccount";
import { blurAllInputField } from "../../../../utils";

const CONTACT_TYPE_OPTIONS = [
  { value: "Customer", label: "Customer" },
  { value: "Supplier", label: "Supplier" },
];

const EnhancementContactForm = ({ customers, business, id }) => {
  const [I18n] = useContext(LanguageContext);
  const { user } = useAuthContext();
  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();
  const isSendReminder = location?.state?.isSendReminder;
  const isFromAccountDetail = location?.state?.isFromAccountDetail;
  const [isDirty, setDirty] = useState(false);
  const [editData, setEditData] = useState(null);
  const [state, setState] = useState({
    name: "",
    phone: "",
    contactType: "Customer",
  });

  const [error, setError] = useState(
    isSendReminder ? I18n.enter_number_to_send_reminder : "",
  );
  const [isLoading, setIsLoading] = useState(false);
  const [exist, setExist] = useState(false);
  const [convertAccountTypeLoader, setConvertAccountTypeLoader] =
    useState(false);
  const [transaction_sms, setTransactionSms] = useState(false);
  const [open, setOpen] = useState(false);
  const [isContactTypeChange, seIsContactTypeChange] = useState(false);
  const inputNameRef = useRef();

  const handleContactTypeToggle = (value) => {
    setDirty(true);
    triggerLogEvent(analytics, "acc_type_toggle", { type: value });
    setState((preState) => ({
      ...preState,
      contactType: value,
    }));
  };

  useEffect(() => {
    if (location?.state)
      setState((e) => ({
        ...e,
        name: location?.state?.name || "",
        phone: location?.state?.phone || "",
        contactType: location?.state?.isSupplier ? "Supplier" : "Customer",
      }));
  }, [location]);

  useEffect(() => {
    if (inputNameRef?.current) inputNameRef.current.focus();
    if (id)
      findCustomerByID(id)
        .then((res) => {
          setEditData(res);
          setState({
            name: res?.name || "",
            phone: res?.phone || "",
            contactType: res?.is_supplier ? "Supplier" : "Customer",
          });
          setTransactionSms(res && res.phone ? res.transaction_sms : false);
        })
        .catch((err) => {
          showSnackbar({
            message: I18n.user_not_found_create_an_account,
            severity: "error",
            icon: "",
          });
          navigate("/Accounts");
        });
  }, [id]);

  const onChangeText = (key, text) => {
    setError("");
    setDirty(true);
    if (key === "name" && text.length >= 1 && state.name.length === 0)
      triggerLogEvent(analytics, "acc_name_start");
    if (key === "phone" && text.length >= 1 && state.phone.length === 0)
      triggerLogEvent(analytics, "acc_number_start");
    setState((preState) => ({
      ...preState,
      [key]: text,
    }));
  };

  const isValidForm = () => {
    let patt = /03[0-9]{2}(?!1234567)(?!1111111)(?!7654321)[0-9]{7}/; // VALIDATION FOR PAKISTANI MOBILE NUMBER
    if (state.phone && state.phone.match(patt) === null) {
      setError(I18n.phone_number_format);
      return false;
    }
    setError("");
    return true;
  };

  const isSupplier = state.contactType !== "Customer";

  const onSave = (e) => {
    e?.preventDefault();
    if (isLoading) return;
    setIsLoading(true);
    if (!isValidForm()) {
      setIsLoading(false);
      return;
    }
    if (editData?.id) {
      triggerLogEvent(analytics, "acc_edit_save");
      if (state.phone.length) {
        if (state.phone !== editData?.phone) {
          triggerLogEvent(analytics, "acc_edit_number");
        }
        let isExist = isUserExistForUpdation(
          customers,
          state.phone,
          editData.id,
        );
        if (isExist) {
          setError(
            isExist?.is_supplier
              ? I18n.this_number_associate_with_another_supplier
              : I18n.this_number_associate_with_another_customer,
          );
          setIsLoading(false);
          return;
        } else {
          editDetailsToCloud(editData);
        }
      } else editDetailsToCloud(editData);
    } else {
      if (state.phone.length) {
        let exist = isUserExist(customers, state.phone);
        if (exist) {
          if (exist.is_supplier && isSupplier) {
            setError(I18n.this_number_associate_with_another_supplier);
            setIsLoading(false);
            return;
          } else if (exist.is_supplier === false && !isSupplier) {
            setError(I18n.this_number_associate_with_another_customer);
            setIsLoading(false);
            return;
          } else {
            setExist(exist);
            setIsLoading(false);
            return;
          }
        } else {
          createCustomer();
        }
      } else createCustomer();
    }
  };

  const editDetailsToCloud = (editData) => {
    let data = {
      name: state.name,
      phone: state.phone,
      is_supplier: state.contactType !== "Customer",
      transaction_sms: editData.transaction_sms,
    };
    if (!editData?.is_supplier && isSupplier) {
      seIsContactTypeChange(true);
      setIsLoading(false);
      return;
    }
    if (editData?.is_supplier && !isSupplier) {
      seIsContactTypeChange(true);
      setIsLoading(false);
      return;
    }

    try {
      editData
        .updateCustomer(data)
        .then(() => {
          setDirty(false);
          Sync(user.phone_number, navigate);
          setIsLoading(false);
          showSnackbar({
            message: isSupplier
              ? I18n.supplier_updated_successfully
              : I18n.customer_updated_successfully,
            severity: "success",
            icon: "",
          });
          setTimeout(
            () =>
              navigate(
                isSendReminder || isFromAccountDetail
                  ? `/Accounts/AccountDetail/${editData.id}`
                  : `/Accounts`,
              ),
            500,
          );
        })
        .catch((err) => {
          setIsLoading(false);
          showSnackbar({
            message: "Sorry, cannot process the request at the moment",
            severity: "error",
            icon: "",
          });
        });
    } catch (e) { }
  };

  const createCustomer = () => {
    let data = {
      id: uuid(),
      name: state.name,
      phone: state.phone,
      total_outstanding_payment: 0,
      is_supplier: state.contactType !== "Customer",
    };
    business
      .createCustomer(data)
      .then((res) => {
        triggerLogEvent(
          analytics,
          isSupplier ? "acc_supplier_created" : "acc_customer_created",
          {},
        );
        if (state.phone) {
          triggerLogEvent(
            analytics,
            isSupplier ? "acc_supplier_number" : "acc_customer_number",
            {},
          );
        }
        triggerLogEvent(
          analytics,
          isSupplier ? "acc_supplier_type" : "acc_customer_type",
          { type: isSupplier ? "supplier" : "customer" },
        );
        setDirty(false);
        Sync(user.phone_number, navigate);
        setIsLoading(false);
        showSnackbar({
          message: isSupplier
            ? I18n.supplier_added_successfully
            : I18n.customer_added_successfully,
          severity: "success",
          icon: "",
        });
        setTimeout(() => navigate(`/Accounts/AccountDetail/${res.id}`), 500);
      })
      .catch((err) => {
        setIsLoading(false);
        showSnackbar({
          message: "Sorry, cannot process the request at the moment",
          severity: "error",
          icon: "",
        });
      });
  };

  const handleConversion = async () => {
    setConvertAccountTypeLoader(true);
    await exist.toggleConversion(!exist.is_supplier);
    setConvertAccountTypeLoader(false);
    setDirty(false);
    showSnackbar({
      message: exist.is_supplier
        ? I18n.customer_to_supplier
        : I18n.supplier_to_customer,
      severity: "success",
      icon: "",
    });
    triggerLogEvent(analytics, "acc_edit_customer_type", {});
    setTimeout(() => navigate(`/Accounts/AccountDetail/${exist.id}`), 500);
  };

  const handleView = () => {
    if (convertAccountTypeLoader) return;
    setExist(false);
    setDirty(false);
    setTimeout(() => navigate(`/Accounts/AccountDetail/${exist.id}`), 500);
  };

  const handleChangeTypeConversion = async () => {
    setConvertAccountTypeLoader(true);
    let data = {
      name: state.name,
      phone: state.phone,
      is_supplier: !editData.is_supplier,
      transaction_sms: editData.transaction_sms,
    };
    try {
      editData.updateCustomer(data);

      setConvertAccountTypeLoader(false);
      setDirty(false);
      showSnackbar({
        message: editData.is_supplier
          ? I18n.customer_to_supplier
          : I18n.supplier_to_customer,
        severity: "success",
        icon: "",
      });

      triggerLogEvent(analytics, "acc_edit_customer_type", {
        id: editData.id,
        from: !editData.is_supplier ? "Supplier" : "Customer",
        to: !editData.is_supplier ? "Customer" : "Supplier",
      });

      setTimeout(
        () =>
          navigate(`/Accounts`, {
            state: { isSupplier: editData.is_supplier },
          }),
        500,
      );
    } catch {
      setConvertAccountTypeLoader(false);
    }
  };

  const isDisabled = !state.name || isLoading;

  return (
    <Grid
      container
      className={`${styles.root} ${styles.SaleExpenseFormWrapper} ContactForm`}
    >
      <BusinessLoader />
      <Grid item md={12}>
        <TitleAndActionBox
          data={{
            id: "contactForm",
            title: editData
              ? sentenceCase(I18n.edit_contact)
              : sentenceCase(I18n.add_contact),
            isBack: true,
            onBack: () => navigate(-1),
            onDelete: editData
              ? () => {
                setOpen(true);
                triggerLogEvent(analytics, "acc_edit_delete_btn");
              }
              : null,
          }}
        />

        <Box className={styles.formBodyGrid}>
          <Box className={styles.formColumn}>
            <Box
              className={`${styles.formBody} expenseFormBody contactFormBody`}
              onKeyDown={(e) => {
                if (e.key === "Enter" && e.shiftKey) {
                  e.preventDefault();
                  if (!isLoading && state.name) {
                    blurAllInputField();
                    onSave();
                  }
                }
              }}
            >
              <Box className={accountStyles.inputLabelStyle}>
                <ParagraphText
                  className={`${accountStyles.inputLabelStyleText} mb-2`}
                >
                  {sentenceCase(I18n.contact_type)}
                </ParagraphText>
                <Box className={styles.paymentStatusBoxLeft}>
                  <UBRadioBox
                    label={"Customer"}
                    displayLabel={I18n.customer}
                    onChange={(value) => {
                      setDirty(true);
                      triggerLogEvent(analytics, "acc_type_toggle", {
                        type: value,
                      });
                      setState((preState) => ({
                        ...preState,
                        contactType: value,
                      }));
                    }}
                    value={state.contactType}
                  />
                  <UBRadioBox
                    label={"Supplier"}
                    displayLabel={I18n.supplier}
                    onChange={(value) => {
                      setDirty(true);
                      triggerLogEvent(analytics, "acc_type_toggle", {
                        type: value,
                      });
                      setState((preState) => ({
                        ...preState,
                        contactType: value,
                      }));
                    }}
                    value={state.contactType}
                  />
                </Box>
              </Box>
              <form id="contact_form" onSubmit={onSave}>
                <UBInput
                  inputId="contact_name_id"
                  placeholder={I18n.contact_name}
                  onChange={onChangeText}
                  label={I18n.contact_name}
                  required
                  name={"name"}
                  value={state.name}
                  maxLength={72}
                  inputRef={inputNameRef}
                />

                <UBInput
                  inputId="contact_phone_id"
                  label={`${I18n.phone_number}`}
                  onChange={onChangeText}
                  placeholder={I18n.phone_number}
                  error={{ text: error, show: !!error }}
                  maxLength={11}
                  onlyNumbers={true}
                  isLeadingZero={false}
                  value={state.phone}
                  name={"phone"}
                />

                <UBButton
                  id="contact_save_btn"
                  title={<ParagraphText>{I18n.save}</ParagraphText>}
                  loading={isLoading}
                  type="submit"
                  iconComponent={<EnterIcon />}
                  iconPlacement="right"
                  disabled={isDisabled || isLoading}
                  className={"buttonPrimary saveSaleButton"}
                />
              </form>
            </Box>
          </Box>
        </Box>

        <ConfirmationModal
          open={Boolean(exist)}
          onClose={handleView}
          onConfirm={handleConversion}
          message={
            isSupplier
              ? I18n.customer_with_this_number_already_exists
              : I18n.supplier_with_this_number_already_exists
          }
          title={
            isSupplier
              ? I18n.you_can_either_view_customer_details_or_move_to_supplier_tab
              : I18n.you_can_either_view_supplier_details_or_move_to_customer_tab
          }
          cancelText={isSupplier ? I18n.view_customer : I18n.view_supplier}
          confirmText={
            isSupplier ? I18n.move_to_supplier : I18n.move_to_customer
          }
          loading={convertAccountTypeLoader}
          id="contact_exist"
          confirmButtonClassName="ubPrimaryButton"
        />

        <ConfirmationModal
          open={isContactTypeChange}
          onClose={() => seIsContactTypeChange(false)}
          onConfirm={handleChangeTypeConversion}
          message={
            isSupplier
              ? I18n.Are_you_sure_you_want_to_change_the_customer_to_supplier
              : I18n.Are_you_sure_you_want_to_change_the_supplier_to_customer
          }
          title={
            isSupplier ?
              I18n.this_customer_entry_will_be_transferred_to_the_supplier_section :
              I18n.this_supplier_entry_will_be_transferred_to_the_customer_section
          }
          cancelText={I18n.cancel}
          confirmText={
            isSupplier ? I18n.move_to_supplier : I18n.move_to_customer
          }
          loading={convertAccountTypeLoader}
          id="contact_type_change"
          confirmButtonClassName="ubPrimaryButton"
        />

        <RouteLeavingGuard
          id="contactForm"
          when={isDirty}
          confirmText={I18n.discard_contact_btn}
          title={I18n.discard_contact_title}
        />
        {editData ? (
          <DeleteAccount
            id="contactDelete"
            customer={editData}
            onDeleteSuccess={() => {
              triggerLogEvent(analytics, "acc_edit_deleted", {
                from: "acc_edit_delete_btn",
              });
              navigate(`/Accounts`);
            }}
            open={open}
            setOpen={setOpen}
          />
        ) : null}
      </Grid>
    </Grid>
  );
};

const enhance = withObservables(["user"], ({ business }) => ({
  customers: getCustomerOfBusiness(business?.id ? business.id : ""),
}));

export default enhance(EnhancementContactForm);
